import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../components/Icons/BackArrowIcon";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { callApi } from "../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import { useState, useEffect, useRef } from "react";
import { Spinner } from "reactstrap";
import Cookies from "js-cookie";

function VerifyOtp() {
  const [isLoading, setIsLoading] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(59);
  const inputRefs = useRef([]);
  const randomDeviceId = uuidv4();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleOtpChange = (value, index) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move focus to next input if not last input
      if (value && index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "") {
      // Move to the previous input on Backspace
      if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const handleSubmit = () => {
    if (otp.some((digit) => digit === "")) {
      toast.error("Please enter all 6 digits of the OTP.");
      return;
    }

    let deviceId = localStorage.getItem("deviceId") || "2024_" + randomDeviceId;
    localStorage.setItem("deviceId", deviceId);

    const fcmToken = localStorage.getItem("fcmToken");
    const isLogin = location?.state?.type === "login";

    const submitData = {
      ...(location?.state?.data?.email && {
        email: location?.state?.data?.email,
      }),
      ...(location?.state?.data?.phone && {
        phone: location?.state?.data?.phone,
      }),
      ...(isLogin && location?.state?.data?.password && {
        password: location?.state?.data?.password,
      }),
      otp: otp.join(""),
      deviceId: deviceId,
      deviceToken: fcmToken || randomDeviceId.slice(0, 10),
      ...(isLogin && { from: "web" }),
    };

    const options = {
      method: "POST",
      data: submitData,
    };

    let API = isLogin ? apiUrl?.login : apiUrl?.forget_password;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        if (isLogin) {
          Cookies.set("token", response?.data?.token?.accessToken);
          Cookies.set("refreshToken", response?.data?.token?.refreshToken);
          localStorage.setItem("token", response?.data?.token?.accessToken);
          new BroadcastChannel("auth").postMessage({
            type: "login",
            sourceTabId: window.__TAB_ID,
          });
          navigate(RoutesLink?.dashboard);
        } else {
          navigate(RoutesLink?.new_password, { state: { data: submitData } });
        }
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleResendOtp = () => {
    setTimer(59);
    let deviceId = localStorage.getItem("deviceId") || "2024_" + randomDeviceId;
    localStorage.setItem("deviceId", deviceId);
    const fcmToken = localStorage.getItem("fcmToken");
    const isLogin = location?.state?.type === "login";

    let submitData = {
      ...(location?.state?.data?.email && {
        email: location?.state?.data?.email,
      }),
      ...(location?.state?.data?.phone && {
        phone: location?.state?.data?.phone,
      }),
      ...(isLogin && location?.state?.data?.password && {
        password: location?.state?.data?.password,
      }),
      deviceId: deviceId,
      deviceToken: fcmToken ? fcmToken : randomDeviceId.slice(0, 10),
      ...(isLogin && { from: "web" }),
    };
    const options = {
      method: "POST",
      data: submitData,
    };
    let API = isLogin ? apiUrl?.login : apiUrl?.forget_password;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <div className="login-content bg-white">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-lg-7 col-xl-8 px-0">
            <div className="login-img-card">
              <img
                src={"/assets/img/solar-bg.avif"}
                alt="login-solar"
              />
            </div>
          </div>
          <div className="col-12 col-lg-5 col-xl-4 px-0">
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="card login-card shadow-none">
                <div className="card-body">
                  <button
                    className="btn back-arrow bg-light mb-3 p-2"
                    onClick={() => navigate(-1)}
                  >
                    <BackArrowIcon />
                  </button>
                  <form className="text-center" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                    <div className="form-group mb-3">
                      <label
                        htmlFor="OTP"
                        className="form-label fs-3 fw-medium"
                      >
                        Enter OTP
                      </label>
                      <div className="otp-input justify-content-center d-flex gap-2">
                        {otp.map((digit, index) => (
                          <input
                            key={index}
                            type="text"
                            className="form-control text-center"
                            value={digit}
                            required
                            maxLength={1}
                            onChange={(e) =>
                              handleOtpChange(e.target.value, index)
                            }
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            ref={(el) => (inputRefs.current[index] = el)}
                          />
                        ))}
                      </div>
                    </div>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="btn btn-primary py-2 w-100"
                    >
                      {isLoading ? <Spinner /> : "Submit"}
                    </button>
                    <div className="d-flex align-items-center justify-content-center mt-4">
                      <button
                        type="button"
                        className="btn btn-link text-decoration-none p-0 fw-medium text-primary fs-4"
                        onClick={handleResendOtp}
                        disabled={timer > 0}
                      >
                        Resend OTP{" "}
                        {timer > 0 &&
                          `(After 0:${timer.toString().padStart(2, "0")} sec)`}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyOtp;
